import { createAsyncThunk } from '@reduxjs/toolkit';
import { getApi, putApi } from 'apis';

export const fetchProfileAction = createAsyncThunk(
	'auth/fetchProfile',
	async (_, { rejectWithValue }) => {
		try {
			const response = await getApi('/auth/fetch-profile');
			return response.data;
		} catch (error: any) {
			if (!error.response) {
				throw error;
			}
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const updateProfileAction = createAsyncThunk(
	'auth/profile',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await putApi('/auth/profile', data);
			return response?.data;
		} catch (error: any) {
			if (!error.response) {
				throw error;
			}
			return rejectWithValue(error?.response?.data);
		}
	}
);
